import PlusCircleIcon from "assets/icons/HeroIcons/PlusCircleIcon";
import React from "react";
import useCustomBranding from "hooks/useCustomBranding";

interface UserProps {
  userData: any;
  addAdmin: any;
}

export const Users: React.FC<UserProps> = ({ userData, addAdmin }) => {
  const {getBrandPlaceholder} = useCustomBranding();

  return (
    <div className="w-full user-list">
      <div
        onClick={() => addAdmin(userData)}
        className="flex justify-between items-center gap-4 px-3 py-2 hover:bg-bgBluish_2 rounded cursor-pointer">
        <div className="relative flex items-center justify-between cursor-pointer">
          <img
            src={
              userData?.personImage ? userData?.personImage : getBrandPlaceholder("userProfile")
            }
            alt=""
            height="32px"
            width="32px"
            className="object-cover mx-2 Img_user_Data"
            style={{ flexShrink: 0 }}
          />
          <div className="">
            <p className="ml-3 break-words w-[500px] dark:text-textMain">{`${userData.name}`}</p>
            <p className="ml-3 dark:text-textMain text-secondaryMid">{userData.observations} observations</p>
          </div>
        </div>
        <button type="button" onClick={() => addAdmin(userData)}>
          <PlusCircleIcon />
        </button>
      </div>
    </div>
  );
};
